import React from 'react';
import Iframe from 'react-iframe';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ROOT_URL, BANKDATA_URL } from '../../Actions/types'


class FastlinkWizard extends React.Component {

  state = { url: `${BANKDATA_URL}/fastlinktoken/${localStorage.getItem("bookid")}/#${localStorage.getItem('token')}` }

  // shouldComponentUpdate() {
  //   return false;
  // }
  componentDidMount() {
    window.addEventListener('message', this.handleFrameTasks);
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks);
  }
  handleFrameTasks = e => {
    if(e.data === 'closeyodlee') this.props.closeYodlee();
    if(e.data === 'goToYodlee') {
      const { selectedBank } = this.props;
      const siteId = (selectedBank.yodleeFeedId || selectedBank.bankId) - 100000;
      this.setState({ url: `${ROOT_URL}/bankfeed/fastlinklogin?bookid=${localStorage.getItem("bookid")}&cognitotoken=${localStorage.getItem('cognitotoken')}&authorizationtoken=${localStorage.getItem('token')}&flow=add&siteid=${siteId}` });
    }
  };

  render() {
    
    return (
      <div>
        <Iframe
          url={this.state.url}
          width="750px"
          height="620px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
       
      </div>
    );
  }
}
const selector = formValueSelector('feedWizardForm');

FastlinkWizard = connect(state => {
  const selectedBank = selector(state, 'selectedBank');
  return { selectedBank };
})(FastlinkWizard);

export default FastlinkWizard;



// WEBPACK FOOTER //
// ./src/components/FeedManagment/FastlinkWizard.js